
import React from 'react';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import OrderManageSection from './OrderManageSection';
import messages from '../../../locale/messages';

function action({ store, params, intl }) {
  const title = intl.formatMessage(messages.orderManageMent);

  let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

  if (!isStoreAuthenticated) {
    return { redirect: '/store/login' };
  };

  const type = params.type;

  return {
    title,
    component: <DashboardLayout>
      <OrderManageSection title={title} type={type} />
    </DashboardLayout>

  };
}

export default action;
